export default __webpack_public_path__ + "static/media/Check.598c2f7a.svg";